import '../pages/Header.css';

function Footer() {
    return (

        <div className='FooterBody pl-20 pr-20'>
            <div className='Footer-FirstPart'>
                <span className='Footer-text'>Privacy policy</span>
                <span className='Footer-text'>Cookie policy</span>
                <span className='Footer-text'>Terms of use</span>
            </div>
            <div className='Footer-SecondPart'>
                <span>Copyright © 2025 Accenture. All rights reserved. Accenture Confidential. For internal use only.</span>
            </div>
        </div>
    )
}
export default Footer;